import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sign',
  standalone: false,
})
export class SignPipe implements PipeTransform {
  transform(value?: number | undefined): string {
    if (!value) {
      return '';
    }
    if (value < 0) {
      return '-';
    } else {
      return '';
    }
  }
}
